var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, runInAction, makeObservable } from 'mobx';
export class Mutation {
    entity;
    mutationAction;
    mutationCondition;
    startDate;
    endDate;
    constructor(init) {
        makeObservable(this);
        Object.assign(this, init);
    }
    async runMutation() {
        this.startDate = new Date();
        await this.mutationAction();
        runInAction(() => (this.endDate = new Date()));
    }
    get whenResult() {
        return this.mutationCondition();
    }
    get isMutationPending() {
        if (this.isRunning)
            return false;
        if (this.whenResult === false)
            return false;
        return true;
    }
    get hasCompleted() {
        return !!this.endDate;
    }
    get isRunning() {
        return !!this.startDate && !this.hasCompleted;
    }
}
__decorate([
    observable.ref
], Mutation.prototype, "startDate", void 0);
__decorate([
    observable.ref
], Mutation.prototype, "endDate", void 0);
__decorate([
    action.bound
], Mutation.prototype, "runMutation", null);
__decorate([
    computed
], Mutation.prototype, "whenResult", null);
__decorate([
    computed
], Mutation.prototype, "isMutationPending", null);
__decorate([
    computed
], Mutation.prototype, "hasCompleted", null);
__decorate([
    computed
], Mutation.prototype, "isRunning", null);
